// Mock users data
export const mockUsers = [
  {
    id: "user-1",
    email: "operator@artvisage.ru",
    name: "Оператор Мария",
    role: "operator",
    created_at: "2025-10-01T10:00:00Z",
  },
  {
    id: "user-2",
    email: "admin@artvisage.ru",
    name: "Администратор Иван",
    role: "admin",
    created_at: "2025-10-01T10:00:00Z",
  },
];
